var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./scripts/report-history.js"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler?id=data-v-68da290c!../../node_modules/vue-loader/lib/template-loader?raw&engine=pug!./templates/report-history.pug"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/ReportHistory.vue
// module id = 349
// module chunks = 1